module.exports = __webpack_public_path__ + "img/call_after_appointment_icon.412a3dd4.svg";